import { ROUTES } from '@/core/constants/routes'
import { getTranslations } from 'next-intl/server'
import Link from 'next/link'

export async function Error404() {
  const t = await getTranslations()

  return (
    <div className='flex h-screen flex-col gap-2 px-8 lg:px-24'>
      <main className='mb-6 flex flex-col gap-8'>
        <Link
          href={ROUTES.home}
          className='mb-16 flex-1 text-lg font-medium underline transition-opacity hover:opacity-85'
        >
          {t('links.goHome')}
        </Link>
      </main>
    </div>
  )
}
